import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Sidebar from '@components/layout/Sidebar';
import Topbar from '@components/layout/Topbar';
import { useSidebarContext } from '@context/SidebarContext';
import { useSenders } from '@features/senders/hooks/useSenders';

export default function MainLayout() {
  const { senderBadgeCount } = useSenders();
  const { mobileOpen, closeMobile } = useSidebarContext();
  const location = useLocation();

  // Dismiss the mobile drawer on route change (covers programmatic nav too).
  useEffect(() => {
    closeMobile();
  }, [location.pathname, closeMobile]);

  // Lock body scroll while the mobile drawer is open.
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  return (
    <div className="flex min-h-screen flex-col bg-page">
      <Topbar />
      <div className="relative flex min-h-0 flex-1">
        {/* Backdrop behind the mobile drawer (desktop never shows it). */}
        {mobileOpen ? (
          <button
            type="button"
            aria-label="Close menu"
            onClick={closeMobile}
            className="fixed inset-0 top-topbar z-30 bg-black/50 backdrop-blur-sm lg:hidden"
          />
        ) : null}

        <Sidebar senderBadge={senderBadgeCount} />

        <main className="min-w-0 flex-1 overflow-x-hidden">
          <div className="mx-auto min-w-0 max-w-content px-4 py-5 sm:px-6 lg:px-8 lg:py-7">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
